export default class WhatsappTemplateFolder {
  constructor(
    public id: string,
    public name: string,
    public createdAt: string,
    public updatedAt: string
  ) {}
}
